import axios from 'axios';
import { Message, MessageBox } from 'element-ui';

const service = axios.create({
  baseURL: '/api',
  timeout: 5000,
  // withCredentials: true // send cookies when cross-domain requests
});

export default service;
